var exports = {
  "n": "xe533113f--4201ee--row",
};

module.exports = exports;
